export const styles = {
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    pb: 2,
  },
  title: {
    fontSize: '18px',
    fontWeight: 600,
  },
  closeIcon: {
    fontSize: 20,
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 1,
  },
  sectionTitle: {
    fontSize: '14px',
    fontWeight: 600,
  },
  addButtonIcon: {
    fontSize: 16,
  },
  contactItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    mb: 1,
  },
  radio: {
    color: (theme) => theme.palette.grays.gray200,
    '&.Mui-checked': {
      color: (theme) => theme.palette.blues.primaryBlue500,
    },
  },
  formControlLabel: {
    flex: 1,
    '& .MuiFormControlLabel-label': {
      fontSize: '14px',
    },
  },
  deleteButton: {
    color: (theme) => theme.palette.error.main,
  },
  deleteIcon: {
    fontSize: 18,
  },
  section: {
    mb: 3,
  },
  dialogActions: {
    p: 2,
  },
};
